import { call, put, select } from 'typed-redux-saga'

import services from '@services'
import { showError } from '@store/ui/error/actions'
import { setLastServiceResponse } from '@store/session/actions'
import { ApplicationState } from '@store/types'
import { StepRefin } from '@utils/enums'

import { seedError, seedRequest, seedSuccess } from '../actions'

export default function* getSeedSaga() {
  const { accessToken } = yield* select((state: ApplicationState) => state.session)

  try {
    const response = yield* call(services.getSeed, { accessToken: accessToken ?? '' })
    yield put(setLastServiceResponse({ code: 'OK', serviceName: 'getSeed' }))
    yield put(seedSuccess(response.data.seed))
  } catch (error) {
    yield put(setLastServiceResponse({ code: 'ERROR', serviceName: 'getSeed' }))
    yield put(seedError())
    yield put(
      showError({
        title: 'Erro ao buscar informações necessárias',
        message: 'Ocorreu um erro ao buscar informações necessárias.',
        actionTitle: 'Tentar Novamente',
        code: StepRefin.ERRO_BUSCAR_SEED,
        actionCallback: () => seedRequest(),
      }),
    )
  }
}
